module.exports = __webpack_public_path__ + "static/img/case5.078c8713.png";